<template>
  <router-view
    :routeLeadsTo="routeLeadsTo"
    :routeLeadsToTitle="routeLeadsToTitle"
    :sidebarExpandedProp="sidebarExpandedProp"
    :bluredProp="bluredProp"
    @expenseStatus="paymentStatus"
    @clearInputErrorsPayments="clearInputErrors"
    @clearOthersPayments="clearOthers"
    @checkAnyInput="checkAnyInput"
  >
  </router-view>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: "Payments",
    props: {
      sidebarExpandedProp: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        bluredProp: '',
        // We use this in computed for breadcrumb
        isAlreadyPaid: false,
        isFromHistory: false,
        isFromPaymentDetails: false
      }
    },
    computed: {
      ...mapGetters(['IS_PAYABLE_FROM_GETTER']),
      // Used in ExpenseDetails ( FPBreadcrumb )
      routeLeadsTo () {
        return (
        this.isFromHistory ||
        this.isFromPaymentDetails ||
        this.IS_PAYABLE_FROM_GETTER ?
          'History' :
          'Unpaid'
        )
      },
      // Used in ExpenseDetails ( FPBreadcrumb )
      routeLeadsToTitle () {
        return (
          this.isFromHistory ||
          this.isFromPaymentDetails ||
          this.IS_PAYABLE_FROM_GETTER ?
            this.$lang.messages.transactionHistory :
            this.$lang.messages.unpaid
        )
      }
    },
    watch: {
      // Used in ExpenseDetails ( FPBreadcrumb )
      $route (to, from) {
        this.isFromHistory = from.name === 'History';
      }
    },
    methods: {
      paymentStatus (val) {
        /**
         * @description When we are selecting "View" from dropdown table inside /payments/recurring/details/:guid
         * with status different than paid or externall ( 'NOT_PAID' or 'REJECTED' or 'PENDING' ) we want to change the breadcrumb to
         * leads us to /payments/history
         * @param {string} val
         * @return {boolean}
         */
        this.isFromPaymentDetails =
          (
            this.$route.name === 'ExpenseDetailsChildMaintenance' ||
            this.$route.name === 'ExpenseDetailsSpousalMaintenance' ||
            this.$route.name === 'ExpenseDetailsSharedExpense' ||
            this.$route.params.expenseStatus === 'PAID' ||
            this.$route.params.expenseStatus === 'PAID_EXTERNALLY'
          ) &&
            val === 'PAID' ||
            val === 'PAID_EXTERNALLY';
      },
      clearInputErrors(e) {
        this.$validator.errors.remove(e.target.name)
      },
      checkAnyInput() {
        this.bluredProp = ''
      },
      clearOthers(e) {
        this.bluredProp = e.target.name
      }
    }
  }
</script>
